
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blur-face-in-photo",
      function () {
        return require("private-next-pages/blur-face-in-photo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blur-face-in-photo"])
      });
    }
  